// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-hr[data-v-bb0f5016] {\n  border-top: 0 none;\n  border-left: 2px solid #EEE;\n  height: 100%;\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
